import { Clock, FolderLock, Upload, Gavel, Scale, LifeBuoy, Link as LinkIcon, Globe,
  Calendar, Folder, BookOpen, Mail, Phone, Video, Database, Cloud, Shield, CreditCard,
  Briefcase, FileText, ExternalLink, Building2, Landmark, Users, Search, Star, Home } from "lucide-react";

export const LINK_ICONS = {
  clock: Clock, "folder-lock": FolderLock, upload: Upload, gavel: Gavel, scale: Scale,
  "life-buoy": LifeBuoy, link: LinkIcon, globe: Globe, calendar: Calendar, folder: Folder,
  book: BookOpen, mail: Mail, phone: Phone, video: Video, database: Database, cloud: Cloud,
  shield: Shield, "credit-card": CreditCard, briefcase: Briefcase, "file-text": FileText,
  "external-link": ExternalLink, building: Building2, landmark: Landmark, users: Users,
  search: Search, star: Star, home: Home,
};

export const ICON_OPTIONS = Object.keys(LINK_ICONS);
